import { render, staticRenderFns } from "./GroupChatHeader.vue?vue&type=template&id=2ae38360&scoped=true&"
import script from "./GroupChatHeader.vue?vue&type=script&lang=js&"
export * from "./GroupChatHeader.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatHeader.vue?vue&type=style&index=0&id=2ae38360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae38360",
  null
  
)

export default component.exports